import { COLORS } from "components/v3/Theme/colors";

/** Shared layout + typography color for MembershipExpiredBanner-style alerts. */
export const noticeAlertContainerBaseSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.5,
  px: 2,
  py: 1.5,
  borderRadius: "24px",
  color: COLORS.WHITE,
  boxSizing: "border-box"
};

/** Icon sizing aligned with MembershipExpiredBanner (WarningAmberRounded). */
export const noticeAlertIconSx = {
  fontSize: 28,
  flexShrink: 0,
  mt: -0.5
};

export function getNoticeAlertContainerSx(backgroundColor) {
  return {
    ...noticeAlertContainerBaseSx,
    backgroundColor
  };
}
